import React, { forwardRef, ReactNode, MouseEvent } from 'react'

import './SelectButton.css'

type Props = {
  label: string
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
  description: ReactNode
  active?: boolean
  disabled?: boolean
  ariaExpanded?: boolean
  ariaControls?: string
}

export const SelectButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      active,
      label,
      onClick,
      description,
      disabled,
      ariaExpanded,
      ariaControls,
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        className={`will-filter-bar-select-button ${disabled ? 'disabled' : ''}`}
        onClick={(e) => (disabled ? undefined : onClick(e))}
        disabled={disabled}
        aria-expanded={ariaExpanded}
        aria-controls={ariaControls}
        aria-haspopup="true"
        aria-disabled={disabled}
      >
        <span className="select-button-wrapper">
          <div>
            <p className={`select-button-label`}>{label}</p>
            <p
              className={`select-button-description ${active ? 'active' : ''}`}
            >
              {description}
            </p>
          </div>
        </span>
      </button>
    )
  }
)

SelectButton.displayName = 'SelectButton'
